<template>
    <SectionViewLayout
      title="settings.identities.titles.list"
      :content_state="content_state"
      content_class="identities-list"
      close_route="settings"
    >
        <template #actions>
            <RouterButton
                link='/settings/identities/add'
                v-tooltip='"settings.identities.actions.add"'
                icon="fas fa-plus-circle"
            />
        </template>

        <template #content>
            <div>
                <form>
                    <ul class="border-list">
                        <li v-for="identity in identities_controller.identities.items" :key="identity.index">
                            <span
                                @click="onIdentityClick(identity.index)"
                                class="list-name"
                                role="button"
                            >
                                {{identity.id}}
                            </span>
                            <div class="list-actions">
                                <div class="control-group">
                                    <div class="control radio-group" v-tooltip='"settings.identities.set_default"'>
                                        <input
                                        type="radio"
                                        :id="identity.index"
                                        name="radio"
                                        @click="onSetDefault(identity)"
                                        :checked="identity.default"
                                        tabindex="-1"
                                        >
                                        <label :for="identity.index">
                                            {{identity.default ? Language.say('settings.identities.default') : '&nbsp;'}}
                                        </label>
                                    </div>
                                </div>
                                <ActionButton
                                    @click="onIdentityEditClick(identity.index)"
                                    v-tooltip='"settings.identities.actions.edit"'
                                    class="clear"
                                    icon="fas fa-cog"
                                />
                            </div>
                        </li>
                    </ul>
                </form>
            </div>
        </template>
    </SectionViewLayout>
</template>

<script setup>
  import { defineProps }      from 'vue';
  import { useRouter }        from 'vue-router';
  import ActionButton         from '@/vue/Elements/Buttons/ActionButton.vue';
  import RouterButton         from '@/vue/Elements/Buttons/RouterButton.vue';
  import SectionViewLayout from '@/vue/Layouts/Sections/SectionViewLayout.vue';
  import Language             from '@/js/Shared/Language/Language.js';

  const props = defineProps({
    identities_controller : {},
    contacts_controller   : {},
    content_state         : {},
  })

  const route = useRouter();

  const onIdentityClick = (index) => {
    routeToEdit(index);
  }

  const onIdentityEditClick = (index) => {
    routeToEdit(index);
  }

  const onActionClose = () => {

  }

  const routeToEdit = (index) => {
    route.push('/settings/identities/edit/' + index);
  }

  const onSetDefault = (identity) => {
    props.identities_controller.setDefaultIdentity(identity);
  }
</script>
